<template>
    <div class="index-container">
        <b-loading :active="loading"></b-loading>

        <top-section>
            {{ __('strings.user.roles.title') }}
            <template v-slot:buttons>
                <b-button v-if="canCreate" tag="router-link"
                          type="is-primary"
                          class="is-uppercase"
                          :label="__('strings.index.addButton')"
                          :to="{ name: 'model.action', params: {resource: 'roles', action: 'create'} }"></b-button>
            </template>
        </top-section>

        <table-section :data="items"
                       :columns="columns"
                       model="roles"
                       :pagination-endpoint="'/' + $route.params.resource + '/' + $route.params.action"
                       :pagination-route="'/' + $route.params.resource + '/' + $route.params.action"></table-section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            columns: [],
            items: {},
            title: '',
            canCreate: false
        };
    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {
            this.loading = true;
            this.canCreate = false;
            axios.get(`/columns/${this.$route.params.resource}`).then(response => {
                this.columns = response.data;
                axios.get(`/title/${this.$route.params.resource}`)
                    .then(response => this.title = response.data)
                axios.get(`/${this.$route.params.resource}/index`, {params: {paginate: true}})
                    .then(response => {
                        this.items = response.data
                        this.loading = false;
                    })
            })

            this.isAuthorized('users', 'create')
                .then(() => this.canCreate = true);
        }
    },
    watch: {
        $route(to, from) {
            if (to.path !== from.path) {
                this.initPage();
            }
        }
    }
};
</script>
